// External libraries
import React from 'react';
import {
  BANK_NAME_MAP,
  BankLogo,
  CARD_ART_MAP,
} from '@checkout/react-components';
import { useStoreState } from '@/store';

// Internal modules
import { features, logger } from '@/lib';
import {
  CardArtContainer,
  CardIconContainer,
  CardItem,
  CardList,
  SvgWrapper,
} from '../styledComponents';
import { CardIconsBarLoadingElement } from '../Components';

const CreditCardAndBankIconsBar = () => {
  const { allowedBankTypes } = features.config;
  const allowedCardTypes = useStoreState(state => state.api.allowedCardTypes);
  const displayBankLogos = Object.keys(BANK_NAME_MAP).filter(bankName =>
    allowedBankTypes.includes(bankName),
  );

  if (!allowedCardTypes?.length) {
    return <CardIconsBarLoadingElement />;
  }
  /**
   * @todo Add some accessability text saying something along the lines of
   * <dl class="accessibility-text">
   *  <dt>Accepted card types</dt>
   *  <dd>Visa</dd>
   *  <dd>Mastercard</dd>
   *  <dd> ... </dd>
   * </dl>
   */
  return (
    <CardIconContainer data-testid="credit-card-icons-bar">
      <CardList>
        {allowedCardTypes.map(cardType => {
          // This is to prevent the default card logo from displaying
          // if the card icon can't be found
          if (!CARD_ART_MAP.hasOwnProperty(cardType)) {
            logger.warn('weasley_missing_card_art', { cardType });
            return null;
          }

          /**
           * These nested components are a hack for inline SVGs on IE 11. Once
           * we ditch IE 11 we can just do:
           *
           * import { CardArt } from '@checkout/react-components';
           *
           * return (
           *   <CardItem key={cardType}>
           *     <CardArt cardType={cardType} />
           *   </CardItem>
           * );
           */
          const CardArtComponent =
            CARD_ART_MAP[cardType] || CARD_ART_MAP.DEFAULT;

          return (
            <CardItem key={cardType}>
              <CardArtContainer>
                {/* The padding-bottom style is required to be inline */}
                <SvgWrapper style={{ paddingBottom: '63.15%' }}>
                  <CardArtComponent />
                </SvgWrapper>
              </CardArtContainer>
            </CardItem>
          );
        })}
      </CardList>

      {!!displayBankLogos.length && (
        <CardList>
          {displayBankLogos.map(bankName => (
            <CardItem key={bankName}>
              <BankLogo bankName={bankName} />
            </CardItem>
          ))}
        </CardList>
      )}
    </CardIconContainer>
  );
};

export { CreditCardAndBankIconsBar };
